import React from 'react'
import ContentLoader from 'react-content-loader'
import { withOnlyGE, withOnlyPE } from '../Device'

const GeoentityCardHeaderPlaceHolderDesktop = withOnlyGE(props => (
  <ContentLoader speed={2} width={385} height={82} backgroundColor="#e6e6e6" foregroundColor="#cdcdcd" {...props}>
    <rect x="0" y="0" rx="5" ry="5" width="205" height="15" />
    <rect x="0" y="30" rx="5" ry="5" width="88" height="10" />
    <rect x="0" y="50" rx="5" ry="5" width="180" height="10" />
    <rect x="275" y="0" rx="14" ry="14" width="110" height="24" />
  </ContentLoader>
))

const GeoentityCardHeaderPlaceHolderMobile = withOnlyPE(props => (
  <ContentLoader speed={2} width={385} height={120} backgroundColor="#e6e6e6" foregroundColor="#cdcdcd" {...props}>
    <rect x="0" y="5" rx="5" ry="5" width="205" height="15" />
    <rect x="0" y="55" rx="5" ry="5" width="180" height="10" />
    <rect x="0" y="35" rx="5" ry="5" width="88" height="10" />
    <rect x="230" y="80" rx="14" ry="14" width="110" height="24" />
  </ContentLoader>
))

// eslint-disable-next-line react/display-name
export default () => (
  <>
    <GeoentityCardHeaderPlaceHolderDesktop />
    <GeoentityCardHeaderPlaceHolderMobile />
  </>
)
